export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    slug: "search-tips",
    name: "搜索技巧",
    description: "掌握高效搜索方法，精准定位你想要的视频内容，提升发现效率",
    icon: "ri-search-eye-line",
    articleCount: 8,
  },
  {
    slug: "category-nav",
    name: "分类导航",
    description: "全面了解平台内容分类体系，快速浏览各类型视频资源",
    icon: "ri-menu-line",
    articleCount: 7,
  },
  {
    slug: "download-guide",
    name: "下载教程",
    description: "详细下载操作指南，支持多设备多格式视频保存方案",
    icon: "ri-download-2-line",
    articleCount: 6,
  },
  {
    slug: "hot-recommend",
    name: "热门推荐",
    description: "精选热门视频和优质创作者，发现最新最火的精彩内容",
    icon: "ri-fire-line",
    articleCount: 9,
  },
  {
    slug: "usage-tips",
    name: "使用技巧",
    description: "实用操作技巧和隐藏功能揭秘，让你成为平台使用达人",
    icon: "ri-lightbulb-line",
    articleCount: 6,
  },
  {
    slug: "platform-compare",
    name: "平台对比",
    description: "多平台横向对比分析，帮你选择最适合自己的视频平台",
    icon: "ri-bar-chart-line",
    articleCount: 5,
  },
];

export function getCategoryBySlug(slug: string): Category | undefined {
  return categories.find((c) => c.slug === slug);
}